"use client";

import React, { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";

const ROTATING_WORDS = [
  "Learning Intelligence",
  "Institutional Intelligence",
  "Digital Identity",
  "Verified Credentials",
  "Trusted Records",
  "Skills Verification",
  "Career Opportunity",
];

const ROTATE_INTERVAL_MS = 2800;

export const RotatingHeroWord = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % ROTATING_WORDS.length);
    }, ROTATE_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  const currentPhrase = ROTATING_WORDS[index];
  const [firstWord, ...restWords] = currentPhrase.split(" ");
  const rest = restWords.join(" ");

  return (
    <span className="relative grid sm:inline-grid align-top text-center sm:text-left w-full sm:w-auto leading-[0.95]">
      {/* Static text for SEO/screen readers, visually hidden */}
      <span className="sr-only">{ROTATING_WORDS[0]}</span>

      <AnimatePresence mode="wait">
        <motion.span
          key={currentPhrase}
          aria-hidden="true"
          initial={{ y: 24, opacity: 0, filter: "blur(8px)" }}
          animate={{ y: 0, opacity: 1, filter: "blur(0px)" }}
          exit={{ y: -24, opacity: 0, filter: "blur(8px)" }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="col-start-1 row-start-1 inline-block whitespace-normal sm:whitespace-nowrap break-words px-2 sm:px-0"
        >
          <span className="text-red-500">{firstWord}</span>
          {rest && <span className="text-black">&nbsp;{rest}</span>}
        </motion.span>
      </AnimatePresence>
    </span>
  );
};